import type { LineItem, Material } from '../../types/ffe'
import type { CSVColumn } from './types'
import { formatCurrency } from '../currency'

export const getLineItemColumns = (materials: Material[]): CSVColumn[] => [
  {
    key: 'code',
    label: 'Code',
    getValue: (item: LineItem) => item.code
  },
  {
    key: 'name',
    label: 'Name',
    getValue: (item: LineItem) => item.name
  },
  {
    key: 'description',
    label: 'Description',
    getValue: (item: LineItem) => item.description || ''
  },
  {
    key: 'quantity',
    label: 'Quantity',
    getValue: (item: LineItem) => item.quantity
  },
  {
    key: 'costPrice',
    label: 'Cost Price',
    getValue: (item: LineItem) => formatCurrency(item.costPrice)
  },
  {
    key: 'sellPrice',
    label: 'Sell Price',
    getValue: (item: LineItem) => formatCurrency(item.sellPrice)
  },
  {
    key: 'supplier',
    label: 'Supplier',
    getValue: (item: LineItem) => item.supplier || ''
  },
  {
    key: 'supplierItemCode',
    label: 'Supplier Code',
    getValue: (item: LineItem) => item.supplierItemCode || ''
  },
  {
    key: 'leadTime',
    label: 'Lead Time',
    getValue: (item: LineItem) => item.leadTime || ''
  },
  ...materials.map(
    (material): CSVColumn => ({
      key: `material_${material.id}`,
      label: `Material: ${material.name} (${material.unit})`,
      getValue: (item: LineItem) => {
        const materialUsage = item.materials?.find(
          (m) => m.materialId === material.id
        )
        return materialUsage?.quantity || 0
      }
    })
  )
]
